<div class="content">
  <app-checkout-tab (click)="selectStep(0)" [icon]="icons.cart" label="Cart" [active]="cartActive()" />
  <app-checkout-tab (click)="selectStep(1)"  [icon]="icons.truck" label="Shipping" [active]="shippingActive()" />
  <app-checkout-tab (click)="selectStep(2)"  [icon]="icons.payment" label="Payment" [active]="paymentActive()" />
</div>